import { render } from "./CheckListAdmin.vue?vue&type=template&id=a5dfb786"
import script from "./CheckListAdmin.vue?vue&type=script&lang=js"
export * from "./CheckListAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__